import { transferCodeBlockWrappedValue } from '@atlaskit/editor-common/code-block';
import { NodeSelection } from '@atlaskit/editor-prosemirror/state';
import { updateExpandedStateNew } from '../pm-plugins/utils/single-player-expand';
export function setBreakoutWidth(width, mode, pos, isLivePage) {
  return function (state, dispatch) {
    var node = state.doc.nodeAt(pos);
    if (!node) {
      return false;
    }
    var tr = state.tr.setNodeMarkup(pos, node.type, node.attrs, [state.schema.marks.breakout.create({
      width: width,
      mode: mode
    })]);
    if (node.type === state.schema.nodes.expand) {
      updateExpandedStateNew({
        tr: tr,
        node: node,
        pos: pos,
        isLivePage: isLivePage
      });
    } else if (node.type === state.schema.nodes.codeBlock) {
      var newNode = tr.doc.nodeAt(pos);
      var oldNode = node;
      if (newNode) {
        transferCodeBlockWrappedValue(oldNode, newNode);
      }
    }
    tr.setMeta('scrollIntoView', false);

    // keep current selection, necessary to not remove NodeSelection for keyboard resizing
    if (state.selection instanceof NodeSelection && state.selection.node.eq(node)) {
      tr.setSelection(NodeSelection.create(tr.doc, pos));
    }
    if (dispatch) {
      dispatch(tr);
    }
    return true;
  };
}